<template>
  <div>
    <section class="main-content">
        <div class="main-block main-block-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-articles bck-views">
                            <h2 class="title">
                                <span>{{article.title}}</span>
                            </h2>
                            <d
                        </div>
                    </div>
                    <div class="main-block">
                      <div class="container">
                          <div class="row">
                              <p v-html="this.article.context"></p>
                          </div>
                        <div class="articles-items">
                            <div class="articles-box topic-box">
                              <div class="text">
                                <h4 class="title text-primary text-center">頂上故事影片</h4>
                                <div class="row">
                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="this.article.link" ></iframe>
                                          </div>
                                      </div>
                                    </div>
                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="this.article.link2"></iframe>
                                          </div>
                                      </div>
                                    </div>
                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="article.link3"></iframe>
                                          </div>
                                          <blockquote class="blockquote article-blockquote">
                                          </blockquote>
                                      </div>
                                    </div>
                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="this.article.link4"></iframe>
                                          </div>
                                      </div>
                                    </div>

                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="this.article.link5"></iframe>
                                          </div>
                                      </div>
                                    </div>

                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="this.article.link6"></iframe>
                                          </div>
                                      </div>
                                    </div>

                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="this.article.link7"></iframe>
                                          </div>
                                      </div>
                                    </div>

                                    <div class="col-sm-3">
                                      <div class="articles-box videoshare-box">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="this.article.link8"></iframe>
                                          </div>
                                      </div>
                                    </div>
                                </div>

                              </div>
                          </div>
                        </div>
                        <!--影片位置-->
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  name: 'FeaturedPage',
  data () {
    return {
      uri: this.$store.getters.getUri,
      userId: this.$store.getters.getUserID,
      article: Object
    }
  },
  computed: {
    ...mapGetters([
      'getUri'
    ])
  },
  mounted: function () {
    // let article = window.localStorage.getItem('article')
    // article = JSON.parse(article)
    // let id = this.$route.params.id
    // let data = article.filter(function (value) {
    //   // console.log('id:' + id + '====' + value.id)
    //   return value.id === id
    // })
    // this.article = data[0]
    // console.dir('id' + JSON.stringify(this.article))
    let self = this
    let dataPost = Qs.stringify({
      id: this.$route.params.id
    })
    self.$http.post(this.uri + 'Article/getAnArticle', dataPost).then(function (res) {
      let data = res.data
      if (data.status === 200) {
        self.article = data.article
      } else {
        console.log('fail')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// FeaturedPage.vue?7a0bc534